export class TransactionTypes {
    public static readonly Incoming: string = 'Incoming';
    public static readonly Outgoing: string = 'Outgoing';
    public static readonly Kitchen: string = 'Kitchen';
    public static readonly Waste: string = 'Waste';
}
